import { Globe } from 'lucide-react'

import { AuthButton } from '@/web-app/views/users/components/auth-button'

interface SSOAuthButtonProps {
  url?: string
  label: string
}

export function SSOAuthButton({ url, label }: SSOAuthButtonProps) {
  if (!url) return null

  return (
    <AuthButton
      icon={<Globe className='fv:size-4! fv:text-black' />}
      label={label}
      available
      onClick={() => {
        window.location.href = url
      }}
    />
  )
}
